import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-field-change-comment',
  templateUrl: './field-change-comment.component.html',
  styleUrls: ['./field-change-comment.component.css']
})
export class FieldChangeCommentComponent {
  @Input() fieldName: string = '';
  @Input() oldValue: any = null;
  @Input() newValue: any = null;
  @Input() formattedOldValue: string = '';
  @Input() formattedNewValue: string = '';

  @Output() closePanelEmitter: EventEmitter<boolean> = new EventEmitter();
  @Output() onCommentSubmitEmitter: EventEmitter<string> = new EventEmitter();

  comment: string = '';

  onCommentChanged(e: any) {
    this.comment = e.value;
  }

  onDismiss() {
    this.closePanelEmitter.emit(true);
    this.resetForm();
  }

  onSubmit() {
    if (this.isFormValid()) {
      this.onCommentSubmitEmitter.emit(this.comment);
      this.resetForm();
    }
  }

  isFormValid(): boolean {
    return !!(this.comment && this.comment.trim().length > 0);
  }

  resetForm() {
    this.comment = '';
  }

  getFormattedFieldName(): string {
    // Convert camelCase or snake_case to Title Case
    if (!this.fieldName) {
      return '';
    }
    return this.fieldName
      .replace(/([A-Z])/g, ' $1')
      .replace(/_/g, ' ')
      .replace(/^./, str => str.toUpperCase())
      .trim();
  }
}
